module.exports = __webpack_public_path__ + "img/5.f24eb510.jpg";